<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="$url+'/api/adm/users/datatable'"
            actionFild
            @update="update"
            @destroy="destroy"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
	data(){
		return {
            columns: [
                {
                    label: 'Nome',
                    field: 'name',
                    order: 'users.name',
                    sort: 'asc'
                },
                {
                    label: 'E-mail',
                    field: 'email',
                    order: 'users.email',
                    sort: 'asc'
                },
                {
                    label: 'Perfil',
                    field: 'role',
                    order: 'roles.name',
                    sort: 'asc'
                },
            ],
            buttons: [
                {
                    action: 'update',
                    classe: 'btn btn-warning',
                    iconClass: 'fas fa-edit'
                },
                {
                    action: 'destroy',
                    classe: 'btn btn-danger',
                    iconClass: 'fas fa-trash'
                },
            ]
    	}
	},
    methods: {
        update(dado){
            this.$emit('update', dado.id);
        },
        destroy(dado){
            this.$emit('destroy', dado.id);
        }
    }
}
</script>